import { BarList, type BarListData, useChart } from '@chakra-ui/charts';
import { Card, Heading, Stack } from '@chakra-ui/react';
import { memo } from 'react';

import { productCatalog } from 'helpers/fakeData';

const SalesBreakdown = () => {
  const products = productCatalog.filter((p) => p.type !== 'powerbank');
  const chart = useChart<BarListData>({
    sort: { by: 'value', direction: 'desc' },
    data: products.map((product) => ({ name: product.name, value: product.price * 4 })),
    series: [{ name: 'name', color: 'teal.subtle' }],
  });

  return (
    <Card.Root w="full" h="fit-content" bg="surface.background" borderColor="border.light">
      <Card.Header p={2}>
        <Heading size="sm">Total sales breakdown</Heading>
      </Card.Header>
      <Card.Body>
        <Stack gap={2}>
          <BarList.Root chart={chart}>
            <BarList.Content>
              <BarList.Bar cursor="pointer" />
              <BarList.Value valueFormatter={(value) => `GHS${value}`} />
            </BarList.Content>
          </BarList.Root>
        </Stack>
      </Card.Body>
    </Card.Root>
  );
};

export default memo(SalesBreakdown);
